var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"section__title-row"},[_c('v-col',{staticClass:"text-center"},[_c('span',{staticClass:"heading2"},[_vm._v(_vm._s(_vm.advantagesData.fields.title || ""))])])],1),_vm._v(" "),_c('row-icon-text-blocks',{attrs:{"items":_vm.advantagesData.children}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }